module.exports = __webpack_public_path__ + "img/dept-5.63e837a3.svg";